import { Directive, ElementRef, Renderer2, OnInit } from '@angular/core';

@Directive({
  selector: '[appHideElement]'
})
export class HideElementDirective implements OnInit {
  private hiddenToken = 'QUhTRVBJQ0FUSEVO1Q=='; // Token that should hide elements

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    const storedToken = sessionStorage.getItem('token');

    // Hide the element only if the token exists and matches the restricted token
    if (storedToken && storedToken == this.hiddenToken) {
      this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
    }
  }
}
